import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JudgeInfo } from '../../application/application.service';

@Component({
    selector: 'dialog-judgeconfirm-component',
    styleUrls: ['judgeconfirm.dialogcomponent.scss'],
    templateUrl: 'judgeconfirm.dialogcomponent.html',
})

export class JudgeConfirmDialogComponent implements OnInit {
    AllJudges: JudgeInfo[];

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<JudgeConfirmDialogComponent>
    ) { }

    ngOnInit() {
        this.AllJudges = this.data.judges;
    }

    OkHandler() {
        let validJudges = this.AllJudges.filter(j => this.ValidJudge(j));

        this.dialogRef.close(validJudges);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ValidJudge(judge: JudgeInfo): boolean {
        let result = judge.Duplicate === false && judge.Errors.every(e => e === false);
        return result;
    }
}